var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconEssayLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconEssay",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1131.004 223.523v113.1H113.1V1806.93h1470.306v-339.301h113.1v452.402H0V223.523h1131.004ZM1831.096 3l19.227 52.026c30.537 80.188 50.895 167.389 61.074 256.738l-73.515 48.633s38.454 11.31 79.17 22.62c9.048 134.59-3.393 270.31-28.275 392.459v1.13l-97.266 23.752s34.462 23.932 69.92 48.898l3.47 2.445c1.929 1.359 3.857 2.719 5.78 4.076-20.358 76.908-45.24 147.03-74.646 205.843-21.49 42.978-54.289 92.742-99.529 136.851-31.668 31.669-70.122 59.944-113.1 82.564-52.026 27.144-111.97 44.109-180.96 44.109-46.372 0-96.136-7.917-149.293-26.013l-105.184 213.76-95.004 59.943-6.786-110.839 104.052-211.497c-88.218-50.896-149.292-118.756-180.96-203.581-50.896-141.376-1.131-277.096 22.62-332.515l98.397 3.393s-30.537-38.454-58.812-74.647c57.681-98.397 144.768-206.973 249.952-306.502 0 0 72.384-70.122 131.196-113.1 111.97-85.956 237.511-158.34 366.446-202.45L1831.096 3ZM410.26 1181.19c46.032-8.935 113.214 2.149 175.532 106.653 9.048 15.156 17.757 30.877 26.466 46.258 24.09 43.431 57.116 102.809 80.867 104.731 7.351.905 43.543-2.262 124.862-105.183 19.454-24.656 55.08-28.614 79.51-9.274 24.43 19.34 28.614 54.967 9.274 79.396-80.64 101.904-146.465 148.275-211.61 148.275-3.62 0-7.352-.113-11.198-.452-84.146-6.9-128.03-85.957-170.555-162.526-8.143-14.477-16.286-29.067-24.769-43.317-23.977-40.264-45.466-55.985-56.324-53.61-28.388 5.655-77.474 80.867-95.91 207.2-4.636 30.877-34.382 52.366-64.127 47.842-30.99-4.524-52.252-33.252-47.842-64.128 19.228-131.875 78.153-280.376 185.824-301.865ZM1763.236 147.769c-50.896 21.489-100.66 46.37-149.293 75.777-55.42 33.93-109.707 71.253-160.603 113.1-11.31 9.048-21.489 19.227-32.799 29.406l64.468 119.887-133.459-58.812c-82.563 78.039-150.424 160.49-201.319 239.772l71.254 142.507-136.852-16.965c-22.62 63.336-35.061 142.506-7.917 216.022 20.358 57.681 62.205 104.052 123.28 141.375l203.58-408.292c13.572-28.275 47.502-39.585 75.777-26.013 28.276 14.703 39.586 47.502 26.014 75.777l-201.32 404.9c122.15 36.192 214.892 1.13 279.359-49.765 67.86-53.157 104.052-121.017 110.838-135.72 1.131-2.262 2.262-3.393 2.262-5.655 20.358-41.847 37.323-90.48 53.158-141.376-39.586-28.275-130.066-92.742-130.066-92.742l161.734-39.585c18.096-99.529 27.144-206.974 22.62-313.402-15.077-5.925-34.5-13.611-54.128-21.397l-5.7-2.261a60945.32 60945.32 0 0 1-82.679-32.892l131.197-67.747c-6.786-49.764-15.834-99.528-29.406-145.9Z",
      fillRule: "evenodd"
    })));
  }
}
IconEssayLine.glyphName = 'essay';
IconEssayLine.variant = 'Line';
IconEssayLine.displayName = 'IconEssayLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconEssayLine.propTypes = {
  ...SVGIcon.propTypes
};
IconEssayLine.allowedProps = [...SVGIcon.allowedProps];
export default IconEssayLine;
export { IconEssayLine };